import React, { MouseEventHandler, useContext, useEffect } from "react";
import AppDivisionContext from "../../../contexts/AppDivisionContext";
import { useOffline } from "../../../contexts/OfflineContext";
import Popper from "../../Shared/Popper/Popper";

export interface IDivisionPopperProps {
  handleClose: MouseEventHandler;
  coordinates: {
    right: number;
    top: number;
  };
  onChange: (division?: number) => void;
}

const DivisionPopper: React.FC<IDivisionPopperProps> = ({
  handleClose,
  coordinates,
  onChange = null,
}) => {
  const appDivisionContext = useContext(AppDivisionContext);
  const { refetchDivisions } = useContext(AppDivisionContext);
  const isOffline = useOffline();

  useEffect(() => {
    refetchDivisions();
  }, []);

  const handleClick = (divisionId: number) => (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) => {
    if (isOffline) {
      handleClose(e);
      return;
    }

    appDivisionContext.saveAppDivisionId(divisionId);
    if (onChange) {
      onChange(divisionId);
    }
    handleClose(e);
  };

  return (
    <Popper coordinates={coordinates} handleClose={handleClose}>
      <ul>
        {appDivisionContext.divisions.map(
          (division: { id: number; name: string }) => {
            return (
              <li
                className="pointer"
                onClick={handleClick(division.id)}
                key={division.id}
                value={division.id}
                style={isOffline ? { opacity: 0.6, cursor: "not-allowed" } : {}}
              >
                {division.name}
              </li>
            );
          },
        )}
      </ul>
    </Popper>
  );
};

export default DivisionPopper;
